var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"breadcrumbs",attrs:{"items":_vm.items,"divider":"/"},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('router-link',{staticClass:"link",attrs:{"to":{ name: props.item.href }}},[_vm._v(_vm._s(props.item.name))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }